import Image from 'next/image';

import clsx from 'clsx';

// Images
import first_stats from '../../../../public/images/modals/modalFirstStats/first_stats.webp';

const Layout = ({ className, children }) => {
    return (
        <div
            className={clsx('flex flex-col lg:flex-row', className)}
            data-testid="first-stats-layout">
            {children}
        </div>
    );
};

const MainContent = ({ children }) => {
    return <div className="flex-1 p-6 xs:p-10 xl:p-20">{children}</div>;
};

Layout.MainContent = MainContent;

const SideContent = ({ children }) => {
    return (
        <div className="flex w-full flex-col bg-icoGray-100 dark:bg-icoDarkMode-deepBlack lg:w-[330px]">
            <div className="flex-1 p-6 xs:p-10">{children}</div>
            <Image alt="" width={330} height={125} src={first_stats} className="hidden lg:block" />
        </div>
    );
};

Layout.SideContent = SideContent;

export default Layout;
